<template>
  <b-container fluid>
    <page-title icon="fas fa-tachometer-alt" :countdown="countdown" :countdown-max="60">
      <translate>Summary and Control</translate>
    </page-title>
    <summary-panel ref="summaryComponent" @dateRangeUpdated="setTimeout" />
    <control-panel ref="controlPanel" />
  </b-container>
</template>

<script>
import SummaryPanel from '@/components/SummaryPanel'
import ControlPanel from '@/components/ControlPanel'

export default {
  name: 'SummaryPage',
  title() {
    return this.$gettext('Summary')
  },
  components: {
    SummaryPanel,
    ControlPanel
  },
  data() {
    return {
      intervalSummary: null,
      intervalCountdown: null,
      countdown: 60
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setTimeout()
    })
  },
  beforeDestroy() {
    clearTimeout(this.intervalSummary)
    clearInterval(this.intervalCountdown)
  },
  methods: {
    setTimeout() {
      clearTimeout(this.intervalSummary)
      this.intervalSummary = null
      this.intervalSummary = setTimeout(() => {
        this.setTimeout()
      }, 60000)
      this.reloadData()
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.intervalCountdown = null
      this.intervalCountdown = setInterval(() => {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }, 1000)
    },
    reloadData() {
      this.$refs.summaryComponent.fetchData()
      this.$refs.controlPanel.getConfirmeds()
      this.$refs.controlPanel.fectchIncidences(1)
      this.$refs.controlPanel.fectchIncidences(7)
      this.countdown = 60
      this.setIntervalCountdown()
    }
  }
}
</script>
